// extracted by mini-css-extract-plugin
export default {"root":"ShopItem_root__wwtWF","picture":"ShopItem_picture__LCzUe"};